import React from "react";
import { Redirect } from "react-router-dom";
import { Alert, Row, Col, Form, FormControl, Button } from "react-bootstrap";
import {
  fetchProgram,
  putProgram,
  postProgram,
  deleteProgram,
} from "./services/DataService";
import DeleteAlert from "./components/DeleteAlert";
import "./style/form.scss";
import { datetimeToString } from "./services/UtilityService";
import DateTimePicker from "react-datetime-picker";

class AddProgram extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      days: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ],
      types: ["Music", "Dead Air", "News", "Other"],
      selected: "",
      name: " ",
      startDatetime: new Date(),
      endDatetime: new Date(),
    };
    this.onStatusChange = this.onStatusChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onDeleteCallback = this.onDeleteCallback.bind(this);
    this.submitCallback = this.submitCallback.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      fetchProgram(this.props.match.params.id).then((program) => {
        var startDatetime = new Date(
          program.start_date.slice(0, 11) + program.start_time
        );
        var endDatetime = new Date(
          program.end_date.slice(0, 11) + program.end_time
        );
        var type = this.state.types
          .filter(
            (type) =>
              type.slice(0, 2).toLowerCase() === program.type.toLowerCase()
          )
          .toString();
        this.setState({
          ...program,
          startDatetime: startDatetime,
          endDatetime: endDatetime,
          selected: type,
        });
      });
    }
  }

  onStatusChange(e) {
    this.setState({ status: e.target.value });
  }

  submitCallback() {
    this.setState({
      alert: (
        <Alert variant="secondary">
          <Alert.Heading>Submission Successful</Alert.Heading>
          <hr />
          <p>The program has been added/updated.</p>
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => this.setState({ redirect: "/programs" })}
              variant="outline-secondary"
            >
              Close
            </Button>
          </div>
        </Alert>
      ),
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    this.setState({ validated: true });
    var isValid = form.checkValidity();
    var program = {};

    program.id = parseInt(this.state.id);
    program.monday = this.state.monday ?? false;
    program.tuesday = this.state.tuesday ?? false;
    program.wednesday = this.state.wednesday ?? false;
    program.thursday = this.state.thursday ?? false;
    program.friday = this.state.friday ?? false;
    program.saturday = this.state.saturday ?? false;
    program.name = this.state.name;
    program.syndicated = this.state.syndicated;
    program.start_time = datetimeToString(this.state.startDatetime).slice(
      11,
      19
    );
    program.end_time = datetimeToString(this.state.endDatetime).slice(11, 19);
    program.start_date = datetimeToString(this.state.startDatetime).slice(
      0,
      10
    );
    program.end_date = datetimeToString(this.state.endDatetime).slice(0, 10);
    program.type = this.state.selected.slice(0, 2).toUpperCase();
    program.description = this.state.description ?? " ";
    program.syndicated = this.state.syndicated ?? false;

    if (isValid) {
      if (this.props.match.params.id) {
        putProgram(program.id, program).then(this.submitCallback);
      } else {
        postProgram(program).then(this.submitCallback);
      }
    }
  };

  onDelete() {
    this.setState({ deleteAlert: true });
  }

  onDeleteCallback() {
    this.setState({ deleteAlert: false, redirect: "/programs" });
  }

  onChange = (e) => this.setState({ [e.target.name]: !e.target.value });

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.alert) {
      return this.state.alert;
    }
    let deleteAlert;
    if (this.state.deleteAlert) {
      deleteAlert = (
        <DeleteAlert
          onConfirm={() => {
            deleteProgram(this.state.id).then(this.onDeleteCallback);
          }}
          onCancel={() => this.setState({ deleteAlert: false })}
        />
      );
    }
    let deleteButton;
    if (this.props.match.params.id) {
      deleteButton = (
        <div className="d-flex justify-content-center">
          <Button
            variant="danger"
            className="btn-delete"
            onClick={this.onDelete}
          >
            Delete
          </Button>
        </div>
      );
    }
    return (
      <div>
        {deleteAlert}
        <div className="form-title">
          {this.props.match.params.id ? "Edit" : "Add"} a Program
        </div>
        <Form
          className="form"
          noValidate
          validated={this.state.validated}
          onSubmit={this.handleSubmit}
        >
          <Form.Group as={Row}>
            <Form.Label
              column
              sm="3"
              className="d-flex align-items-center flex-row-reverse"
            >
              Schedule
            </Form.Label>
            <Col className="d-flex" sm="7">
              {this.state.days.map((day) => (
                <Col sm="2" key={day}>
                  <Form.Label className="d-flex justify-content-center">
                    {day.charAt(0).toUpperCase() + day.slice(1, 3)}
                  </Form.Label>
                  <Form.Control
                    type="checkbox"
                    name={day}
                    onChange={() => {
                      this.setState({ [day]: !this.state[day] });
                    }}
                    checked={this.state[day] || ""}
                  />
                </Col>
              ))}
            </Col>
            <Form.Label
              column
              sm="3"
              className="d-flex align-items-center flex-row-reverse  mb-2"
            >
              Name
            </Form.Label>
            <Col sm="8">
              <Form.Control
                required
                type="text"
                name="name"
                placeholder="Program Nme"
                onChange={(event) =>
                  this.setState({ name: event.target.value })
                }
                value={this.state.name || ""}
                className="mb-0"
              />
              <Form.Control.Feedback type="invalid">
                Please provide a name of the program.
              </Form.Control.Feedback>
            </Col>

            <Form.Label
              column
              sm="3"
              className="d-flex align-items-center flex-row-reverse  mb-2"
            >
              Start
            </Form.Label>
            <Col sm="8">
              <DateTimePicker
                showTimeSelect="false"
                className="form-control"
                value={this.state.startDatetime}
                onChange={(dt) => {
                  this.setState({ startDatetime: dt });
                }}
              />
            </Col>
            <Form.Label
              column
              sm="3"
              className="d-flex align-items-center flex-row-reverse  mb-2"
            >
              End
            </Form.Label>
            <Col sm="8">
              <DateTimePicker
                showTimeSelect="false"
                className="form-control"
                value={this.state.endDatetime}
                onChange={(dt) => {
                  this.setState({ endDatetime: dt });
                }}
              />
            </Col>
            <Form.Label
              column
              sm="3"
              className="d-flex align-items-center flex-row-reverse mb-2"
            >
              Type
            </Form.Label>
            <Col sm="8">
              <FormControl
                required
                as="select"
                name="type"
                onChange={(event) =>
                  this.setState({ selected: event.target.value })
                }
                value={this.state.selected}
              >
                <option value="0" key="0">
                  Select a type
                </option>
                {this.state.types.map((type, index) => {
                  return (
                    <option value={type} key={index}>
                      {type}
                    </option>
                  );
                })}
              </FormControl>
            </Col>
            <Form.Label
              column
              sm="3"
              className="d-flex align-items-center flex-row-reverse"
            >
              Description
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="text"
                name="description"
                placeholder="description"
                onChange={(event) =>
                  this.setState({ description: event.target.value })
                }
                value={this.state.description || ""}
              />
            </Col>
            <Col
              sm="3"
              className="d-flex align-items-center flex-row-reverse mb-2"
            >
              <Form.Label className="d-flex justify-content-center">
                Syndicated
              </Form.Label>
            </Col>
            <Col sm="8">
              <Form.Control
                type="checkbox"
                name="Syndicated"
                onChange={() =>
                  this.setState({ syndicated: !this.state.syndicated })
                }
                checked={this.state.syndicated || false}
              />
            </Col>
          </Form.Group>
          <div className="d-flex justify-content-center">
            <div style={{ width: "95px" }}></div>
            <Button variant="primary" type="submit" className="btn-submit">
              {this.props.match.params.id ? "Update" : "Add"}
            </Button>
            {deleteButton}
          </div>
        </Form>
      </div>
    );
  }
}

export default AddProgram;
